<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Periodicidade</label>
    </div>
    <tab-navegacao :active_tab="active_tab" />
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn
            color="info"
            to="/periodicidade/criar"
            v-if="isAllowed(14)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="periodicidades.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <!--<v-btn
            @click="baixarlista()"
            v-if="periodicidades.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>-->
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(14)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroPlanoManutencao";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "listaPeriodicidade",
  data() {
    return {
      loading: false,
      search: "",
      showAtivo: false,
      active_tab: 3,
      headers: [
        {
          text: "Id", align: "start", value: "id",
        },
        { text: "Descrição", value: "descricao" },
        { text: "Quantidade Horas", value: "quantidadeHoras" },
        { text: "Status", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      filters: {
        descricao: [],
        quantidadeHoras: [],
      },
    };
  },
  computed: {
    ...mapState("periodicidade", ["periodicidades"]),
    filteredList() {
      if (this.showAtivo === false) {
        var newList = this.periodicidades.filter((p) => {
          return (
            (p.descricao.toLowerCase().includes(this.search.toLowerCase()) ||
            p.quantidadeHoras.toLowerCase().includes(this.search.toLowerCase())) &&
            p.ativo === true
          );
        });
        return newList.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        }).sort( function ( a, b ) { return b.id - a.id; } );
      } else {
        var novaLista = this.periodicidades.filter((p) => {
          return p.descricao.toLowerCase().includes(this.search.toLowerCase()) ||
            p.quantidadeHoras.toLowerCase().includes(this.search.toLowerCase());
        });
        return novaLista.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        }).sort( function ( a, b ) { return b.id - a.id; } );
      }
    },
  },
  methods: {
    ...mapActions("periodicidade", ["atualizarPeriodicidades", "atualizarPeriodicidade"]),
    editar(periodicidade) {
      this.atualizarPeriodicidade(periodicidade);
      if (this.isAllowed(14)) {
        this.$router.push(`/periodicidade/editar`);
      } else {
        this.$router.push(`/periodicidade/ver`);
      }
    },
    baixarlista() {
      //downloadLista();
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarPeriodicidades();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    columnValueList(val) {
      return this.filteredList.map((d) => d[val]);
    },
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  components: {
    TabNavegacao,
  },
};
</script>
